const getConstraints = () => ({
	name: {
		presence: {allowEmpty: false},
	},
	createdBy: {
		presence: {allowEmpty: false},
	},
	updatedBy: {
		presence: {allowEmpty: false},
	},
});

module.exports = {
	getConstraints,
};
